import { classnames } from 'tailwindcss-classnames';
import { Data } from '.generated/templates/Feature.Data.model';
import React from 'react';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import useExperienceEditor from 'lib/sitecore/use-experience-editor';
import type { Graph } from 'schema-dts';
import sanitizeHtml from 'sanitize-html';
import Head from 'next/head';

export type FAQSchemaProps = Sitecore.Override.ComponentBase & Data.Seo.Fields.FaqSchema;
export type FAQSchemaQuestionItemProps = Sitecore.Override.ItemEx &
  Data.Seo.Fields.FaqSchemaQuestionItem;

const FAQSchema = ({ fields }: FAQSchemaProps): React.JSX.Element => {
  const isExperienceEditor = useExperienceEditor();

  if (isExperienceEditor) {
    return <div className={classnames('w-full', 'text-center')}>Click here to edit FAQ Schema</div>;
  }

  const faqQuestionItems = fields?.faqItems.map((item) => {
    return {
      ...(item as unknown as FAQSchemaQuestionItemProps),
    };
  });

  const faqSchemaJson: Graph = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'FAQPage',
        mainEntity:
          faqQuestionItems?.map((item) => ({
            '@type': 'Question',
            name: item?.fields?.['FAQ Schema Question'].value,
            acceptedAnswer: {
              '@type': 'Answer',
              text: item?.fields?.['FAQ Schema Answer'].value,
            },
          })) || [],
      },
    ],
  };
  const faqSchemaJsonString = sanitizeHtml(JSON.stringify(faqSchemaJson));
  const id = 'nmdp-seo-faqschema';
  return (
    <Head>
      <script
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: faqSchemaJsonString }}
        type="application/ld+json"
        key={id}
        id={id}
      />
    </Head>
  );
};

export default FAQSchema;
